module.exports = __webpack_public_path__ + "static/media/parents.0ea0f5cc.svg";